import { render, staticRenderFns } from "./PasswordLessLoginForm.vue?vue&type=template&id=26776910&scoped=true&"
import script from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"
export * from "./PasswordLessLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26776910",
  null
  
)

export default component.exports